import axios from "axios";
import { triggerAuthError } from "./authErrorHandler";

let isRefreshing = false;

axios.interceptors.response.use(
  resp => resp,
  async error => {
    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !isRefreshing) {
      isRefreshing = true;

      const userData = JSON.parse(localStorage.getItem('user'));

      if (userData?.data?.refresh_token) {
        try {
          const response = await axios.post(
            process.env.REACT_APP_BACK_API_URL + 'token/refresh/',
            { refresh: userData.data.refresh_token },
            {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: true
            }
          );

          if (response.status === 200) {
            axios.defaults.headers.common['Authorization'] =
              `Bearer ${response.data.access}`;

            localStorage.setItem('access_token', response.data.access);

            isRefreshing = false;
            return axios(error.config);
          }
        } catch (_) {}
      }

      isRefreshing = false;
      triggerAuthError(); // Notifica a UI
    }

    return Promise.reject(error);
  }
);